<section class="realtime-device-map">
  <div *ngIf="apiLoaded | async">
    <search-menu class="search-menu"
                 [selectedDevice]="selectedDevice"
                 (streamRequest)="loadStream($event)"
                 [devices]="devices"
                 [streamEnabled]="streamEnabled"
                 [@menuAnimate]="searchMenuOpen ? 'menuOpen' : 'menuClosed'">

    </search-menu>

    <mat-card class="device-location-map"
              [@mapAnimate]="searchMenuOpen ? 'menuOpen' : 'menuClosed'">
      <mat-card-content>
        <google-device-map [devices]="devices"
                           (streamRequest)="loadStream($event)"
                           (searchClick)="toggleSearchMenu($event)">

        </google-device-map>
      </mat-card-content>
    </mat-card>

    <stream-viewer *ngIf="selectedDevice"
                   [selectedDevice]="selectedDevice"
                   [selectedWowzaConfig]="selectedWowzaConfig"
                   (close)="deselectDevice()"
                   [@streamAnimate]="searchMenuOpen ? 'menuOpen' : 'menuClosed'">

    </stream-viewer>
  </div>
</section>
